var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgForum(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "svg-icon",
    style: {
      width: "1em",
      height: "1em",
      verticalAlign: "middle",
      fill: "currentColor",
      overflow: "hidden"
    },
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M378.664 544h288.024L680 554.36l43.92 34.168L832 672.6V544h34.664c19.224 0 35.984-7.504 49.568-21.096C929.84 509.312 936 491.232 936 472V136c0-19.232-6.16-37.312-19.768-50.912C902.64 71.488 885.888 64 866.664 64h-488c-19.232 0-38.648 7.488-52.248 21.088C312.824 98.688 304 116.768 304 136v336c0 19.232 8.824 37.312 22.416 50.904 13.6 13.6 33.016 21.096 52.248 21.096zM352 208v-72c0-6.408 3.832-12.44 8.36-16.976 4.536-4.528 11.896-7.024 18.304-7.024h488c6.416 0 11.104 2.496 15.64 7.024 4.528 4.536 5.696 10.568 5.696 16.976v336c0 6.416-1.168 12.44-5.704 16.968s-9.216 7.032-15.632 7.032H784v79.4L744.312 544 728 531.232 682.952 496H378.664c-6.408 0-13.768-2.504-18.304-7.04C355.832 484.44 352 478.416 352 472V208z",
    fill: "#231815"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M335.984 664H624c19.232 0 37.312-9.504 50.904-23.096 7.792-7.784 13.504-17.72 17.016-28.376L648 578.36V588c0 6.424-2.504 14.44-7.032 18.96-4.528 4.544-10.56 9.04-16.968 9.04H319.712l-62.696 46L216 691.4V616H136c-6.408 0-12.44-4.504-16.968-9.032-4.536-4.528-7.032-12.544-7.032-18.968v-336c0-6.408 2.496-10.44 7.024-14.976C123.56 232.496 129.592 232 136 232h136v-48H136c-19.232 0-37.312 5.488-50.912 19.088C71.488 216.688 64 232.768 64 252v336c0 19.232 7.496 39.312 21.088 52.904C98.68 654.504 116.768 664 136 664h32v124.6L335.984 664z",
    fill: "#231815"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M948.504 553.424c-10.472 10.456-22.672 18.144-36.504 21.16v184.832c0 6.424-2.504 12.752-7.032 17.272S894.408 784 888 784h-80v78.8l-41.016-31.096L704.28 784H400c-6.408 0-12.44-2.8-16.976-7.344A24.48 24.48 0 0 1 376 759.4V720h-32.016L328 731.984v27.416c0 19.232 7.496 37.616 21.088 51.208 13.6 13.592 31.68 21.392 50.912 21.392h288.016L856 960v-128h32c19.232 0 37.312-7.8 50.904-21.392S960 778.632 960 759.4V537.128a61.784 61.784 0 0 1-11.496 16.296z",
    fill: "#231815"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForum);
export default __webpack_public_path__ + "static/media/forum.0e66b3e86291581704267864b7bc9158.svg";
export { ForwardRef as ReactComponent };